"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var HitContainerHeader = function HitContainerHeader(_ref) {
  var inputValue = _ref.inputValue,
      hasResults = _ref.hasResults,
      doSearch = _ref.doSearch;
  return !hasResults ? (0, _preact.h)("div", {
    className: "algolia-hit-container__header"
  }, (0, _preact.h)("a", {
    onClick: function onClick() {
      return doSearch(inputValue);
    },
    className: "algolia-search-submit-link"
  }, (0, _preact.h)("span", {
    className: "algolia-hit-container__header-text"
  }, inputValue ? hasResults ? (0, _preact.h)(_phrase.default, {
    p: "live.search.search.text"
  }) : (0, _preact.h)(_phrase.default, {
    p: "live.search.no.result.found.text"
  }) : (0, _preact.h)(_phrase.default, {
    p: "live.search.trending.text"
  })), ' ', inputValue)) : null;
};

var _default = HitContainerHeader;
exports.default = _default;